import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nicknameBlur'
})
export class NicknameBlurPipe implements PipeTransform {
  transform(value: string): string {
    // Extended regex to match 'jabka' and 'run' in any case, as whole words or separated by special characters
    const regex = /(\b|\B)(jabka|run|jabkaskin)(\b|\B)/gi;

    return value.replace(regex, (match, p1, p2, p3, offset, string) => {
      // Check if 'jabka' or 'run' is part of another word (excluding special character separation)
      if (
        offset > 0 &&
        string[offset - 1].match(/\w/) &&
        offset + p2.length < string.length &&
        string[offset + p2.length].match(/\w/)
      ) {
        return match; // Return the original match if it's part of another word
      }

      return '***'; // Otherwise, blur it
    });
  }
}

/* Examples:
- 'Ed Sheerun (run)' -> 'Ed Sheerun (***)'
- 'SoqaRun' -> 'SoqaRun'
- 'kim9p jaBkA fail' -> 'kim9p *** fail'
- 'ᛖᛟᚺᛟᛚᛁᛏᚺ \\Jabka\\' -> 'ᛖᛟᚺᛟᛚᛁᛏᚺ \\***\\'
- 'Razzo_run' -> 'Razzo_***' */
